import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  SAVING: {
    en: 'Saving',
    de: 'Einsparung',
  },
  VALIDATING: {
    en: 'Validating',
    de: 'Validieren',
  },
  LOADING: {
    en: 'Loading',
    de: 'Wird geladen',
  },
  AUTOCOMPLETE_LOADING: {
    en: 'Loading...',
    de: 'Laden ...',
  },
  LOGGING_IN: {
    en: 'Logging in',
    de: 'Einloggen',
  },
  SUBMITTING: {
    en: 'Submitting...',
    de: 'Senden...',
  },
  COPIED: {
    en: 'Copied',
    de: 'Kopiert',
  },
  NOTCOPIED: {
    en: 'Not copied - BB Value saved',
    de: 'Not copied - BB Value saved',
  },
  UPLOAD_SUCCESSFULL: {
    en: 'Upload finished successfully!',
    de: 'Hochladen erfolgreich!',
  },
};
